import { render, staticRenderFns } from "./TemplateDetailsHistory.vue?vue&type=template&id=995d1bda&scoped=true&"
import script from "./TemplateDetailsHistory.vue?vue&type=script&lang=js&"
export * from "./TemplateDetailsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995d1bda",
  null
  
)

export default component.exports